import Comp from './StarRatingInput'
export default Comp
